import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5fe749ce")

_pushScopeId("data-v-5fe749ce")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, "⬅ Prev Project", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "WORK", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Next Project ➡", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("footer", null, [
    _createVNode(_component_router_link, {
      class: "arrow",
      to: { name: 'projects', params: { id: _ctx.prevProject.id } }
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_2,
    _createVNode(_component_router_link, {
      class: "arrow",
      to: { name: 'projects', params: { id: _ctx.nextProject.id } }
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["to"])
  ]))
})